/**
 * 系统工具相关路由
 */

import Layout from '@/layout'

const toolsRouter = {
  // 对司扣罚批量回滚
  BatchRollbackDriver: () => import('@/views/system/batch-rollback/index.vue')
}
const toolsRoutes = [
  {
    path: '/tools',
    component: Layout,
    children: [
      {
        path: '/nps-create',
        component: () => import('@/views/system/nps/create.vue'),
        name: 'CreateNps',
        meta: { title: '创建调研' }
      },
      {
        path: '/nps-detail',
        component: () => import('@/views/system/nps/detail.vue'),
        name: 'NpsDetail',
        meta: { title: '调研详情' }
      },
    ]
  }
]

export { toolsRoutes, toolsRouter}
